<template>
  <div class="home">
    <!-- 其他角色首页 -->
    <UserIndex  />
  </div>
</template>

<script>
// import UserIndex from './components/user-index.vue'
export default {
  components: {
    UserIndex: () => import("./components/user-index.vue"),
  },
};
</script>

<style lang="scss" scoped>
</style>
